<template>
  <div>
    <vs-row vs-justify="center" id="membership-box">
      <vs-col vs-w="12">
       <vs-card>
        <!-- Button Add new membership package -->
          <vs-row>
            <vs-col vs-offset="8" vs-lg="3" vs-md="4" vs-sm="6" vs-xs="12" class="d-flex align-items-center">
                <vs-button
                        icon="add"
                        color="primary"
                        @click="addEvent"
                        class="flex-shrink-0 ml-auto w-100"
                        id="create-queues"
                >{{$t('Membership.CreateNewPackage')}}</vs-button>
            </vs-col>
          </vs-row>
       </vs-card>
       <!-- End of Button Add new membership package -->
       <!-- Membership table -->
       <vs-card>
          <vs-row >
             <vs-card>
                    <vs-table
                            :sst="true"
                            @selected="handleSelected"
                            v-model="selected"
                            :total="totalItems"
                            max-items="10"
                            :data="transactions">
                        <div slot="header">

                        </div>
                        <template slot="thead">
                            <vs-th sort-key="contactname">{{$t('SMS.Table.Destination')}}</vs-th>
                            <vs-th sort-key="joindate">{{$t('SMS.Table.Message')}}</vs-th>
                            <vs-th sort-key="phone">{{$t('SMS.Table.SentAt')}}</vs-th>
                        </template>

                        <template slot-scope="{data}">
                            <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">

                                <vs-td :data="data[indextr].destination">
                                    <div class="d-flex no-block align-items-center">
                                        {{ data[indextr].destination }}
                                    </div>
                                </vs-td>

                                <vs-td :data="data[indextr].message">
                                    <div class="d-flex align-items-center">
                                        {{ data[indextr].message }}
                                    </div>
                                </vs-td>

                                <vs-td :data="data[indextr].created_at">
                                    <div class="d-flex align-items-center">
                                        <span class="text-muted">{{data[indextr].created_at}}</span>
                                    </div>
                                </vs-td>

                            </vs-tr>
                        </template>
                    </vs-table>
                    <vs-pagination :total="totalPages" @change="handleChangePage" v-model="currentPage"></vs-pagination>
                </vs-card>
          </vs-row>
      </vs-card>
      <!-- End of Membership table -->
      </vs-col>
    </vs-row> 
  </div>
</template>

<script>z
export default {
  name: "Membership",
  data: () => ({
    title: "Membership",
  }),
  methods: {
    
  },
  computed: {
    
  },
  components: {
  },
  mounted() {
    
  }
};
</script>
